// extracted by mini-css-extract-plugin
module.exports = {"container":"TypeformEmbed_container__xAsLa","tall":"TypeformEmbed_tall__r23lX","short":"TypeformEmbed_short__o1Ylm"};